// Modal.jsx
import React from 'react';
import { IoClose } from "react-icons/io5";

type Props = {
  title: string;
  isOpen: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  disabledButton: boolean;
  children: React.ReactNode;
  labelCancel?: string;
  labelConfirm?: string;
  showFooter?: boolean;
  footerComponent?: React.ReactNode;
};

const Modal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  disabledButton = false,
  labelCancel,
  labelConfirm,
  showFooter = true,
  footerComponent
}: Props) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl max-h-[70vh] mx-4 overflow-y-scroll">
        <div className='w-full sticky top-0 bg-white shadow-md p-6'>
          <h2 className="text-xl font-semibold mb-0">{title}</h2>
          <button
            className='absolute top-6 right-6 transition-all ease-in-out duration-300 hover:scale-105'
            onClick={onClose}
          >
            <IoClose size={25} className='font-bold' />
          </button>
        </div>
        {children}
        {showFooter &&
          <>
            <hr className='my-4' />
            <div className="flex justify-between space-x-4">
              <button
                disabled={disabledButton}
                onClick={onClose}
                className="px-4 py-2 bg-red-300 text-red-800 rounded-xl hover:bg-red-500 hover:text-white transition-all ease-in-out duration-300 font-semibold"
              >
                {labelCancel || "Cancel"}
              </button>
              <button
                disabled={disabledButton}
                onClick={onConfirm}
                className="px-4 py-2 bg-blue-900 text-white rounded-xl hover:bg-blue-600 transition-all ease-in-out duration-300 font-semibold disabled:bg-gray-400 cursor-pointer disabled:cursor-not-allowed"
              >
                {labelConfirm || "Confirm"}
              </button>
            </div>
          </>
        }
        { footerComponent && 
          <div className='px-6 py-4'>
            {footerComponent}
          </div>
        }
      </div>
    </div>
  );
};

export default Modal;